import { useContext, createContext} from "react";

export const WalletContext = createContext({})

export default function useWallet() {
  return useContext(WalletContext)
}